import { render, staticRenderFns } from "./addOutbox.vue?vue&type=template&id=0a0108ce&scoped=true"
import script from "./addOutbox.vue?vue&type=script&lang=js"
export * from "./addOutbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0108ce",
  null
  
)

export default component.exports